import styled from "styled-components/macro";

export const DivClientRegisterPageContainer = styled.div`
  padding: var(--g5) 0 var(--g10);
`;
